<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{ 'SELECT_SAVED_ADDRESS' | translate }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="filters">
      @for (filter of filters; track filter) {
        <button
          class="button button--xs"
          [routerLink]
          [queryParamsHandling]="'merge'"
          [queryParams]="{ type: filter.value }"
          [ngClass]="{
            'button--outlined active text-primary':
              filter.value == queryParams?.type,
          }"
          type="button"
        >
          {{ filter.title | translate }}
        </button>
      }
    </div>

    <h3 class="doble-space-between">
      <span>{{ 'YOUR_SAVED_ADDRESSES' | translate }}</span>

      @if (items?.data?.length) {
        <a
          (click)="createItem()"
          class="float-right button button--filled button--sm"
        >
          {{ 'NEW_ADDRESS' | translate }}
        </a>
      }
    </h3>

    <div
      #root
      class="root-block"
      (appDeferLoad)="onScroll()"
      [root]="root.nativeElement"
    >
      @for (item of items?.data; track item) {
        <div #element>
          <article
            class="personal-item personal-item--opened"
            [ngClass]="{
              'personal-item--active': isPersonalItemActiveClass(item),
            }"
            (click)="selectItem(item)"
            #element
          >
            <header
              class="personal-item__section personal-item__section--header clearfix"
            >
              <div class="float-right trash-block ml-3">
                @if (item.is_default) {
                  <div class="text-secondary">{{ 'DEFAULT' | translate }}</div>
                }
              </div>
              <h3 class="personal-item__title">
                {{ item.address }}
              </h3>
              @if (item.comment) {
                <h5 class="personal-item__sub-title">{{ item.comment }}</h5>
              }
            </header>
          </article>
        </div>
      }
    </div>

    @if (!items?.data?.length) {
      @if (!items) {
        <div class="row">
          <div class="col-12 text-center">
            <span
              class="spinner-border spinner-border spinner-border-lg text-secondary"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </div>
      } @else {
        <button
          (click)="createItem()"
          type="button"
          class="modern-add-button modern-add-button--sm"
        >
          {{ 'NEW_ADDRESS' | translate }}
        </button>
      }
    }
  </div>
</div>
